import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'visible'
  }
});
//# sourceMappingURL=styles.js.map